import { Configure, InstantSearch } from 'react-instantsearch';
import { HOME_SEARCH_INDEX_ID } from '@/lib/services/typesense/constants';
import {
  TYPESENSE_PUBLISHED_PRODUCTS_FILTER,
  typesenseNavigationTypeInstantSearchFilter,
} from '@/lib/services/typesense/typesense-search-config';
import { productSearchClient } from '@/lib/services/typesense/client/product-search';
import { createInstantSearchRouterNext } from 'react-instantsearch-router-nextjs';
import { VirtualRefinementList } from '../VirtualWidgets/VirtualRefinmentList';
import { VirtualSearchBox } from '../VirtualWidgets/VirtualSearchBox';
import singletonRouter from 'next/router';

const HomeSearchProvider = ({
  children,
  group_id,
  categoryIds,
}: {
  children: React.ReactNode;
  group_id: any;
  categoryIds?: ReadonlyArray<string | number>;
}) => {
  return (
    <InstantSearch
      indexName={HOME_SEARCH_INDEX_ID}
      future={{
        preserveSharedStateOnUnmount: true,
      }}
      searchClient={productSearchClient}
      routing={{
        router: createInstantSearchRouterNext({
          singletonRouter,
          routerOptions: {
            cleanUrlOnDispose: false,
          },
        }),
      }}
    >
      {group_id && (
        <Configure
          filters={`${typesenseNavigationTypeInstantSearchFilter(
            group_id,
            categoryIds,
          )} && ${TYPESENSE_PUBLISHED_PRODUCTS_FILTER}`}
        />
      )}
      <VirtualRefinementList attribute="categories.name" />
      <VirtualSearchBox />
      {children}
    </InstantSearch>
  );
};

export default HomeSearchProvider;
